import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AccountGroup } from '@galaxy/account-group';
import { DurationInterface } from '@vendasta/sales-orders';

export interface OrderDetailsComponentConfig {
  showBusinessName: boolean;
  minContractStartDate: Date;
  showContractDurationHintText: boolean;
}

@Component({
  selector: 'orders-order-details',
  template: `
    <mat-card appearance="outlined">
      <mat-card-header>
        <mat-card-title>
          {{ 'LIB_ORDERS.COMMON.ORDER_DETAILS.TITLE' | translate }}
          <div *ngIf="isLoading">
            <mat-spinner [diameter]="20"></mat-spinner>
          </div>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content class="cols">
        <!-- company -->
        @if (config.showBusinessName) {
          <orders-company-name [business]="business" [url]="companyLink" />
        }

        <!-- address -->
        <orders-company-address [business]="business" />

        <div class="column">
          <span class="row">
            <!-- start -->
            <orders-contract-start
              [minDate]="config.minContractStartDate"
              [viewOnly]="viewOnly"
              [contractStartDate]="contractStartDate"
              (contractStartDateChange)="contractStartDateChanged.emit($event)"
            />
            <!-- duration -->
            <orders-contract-duration
              [contractDuration]="contractDuration"
              [hideHintText]="!config.showContractDurationHintText"
              [viewOnly]="viewOnly"
              (contractDurationChange)="contractDurationChanged.emit($event)"
            />
          </span>
        </div>
      </mat-card-content>
    </mat-card>
  `,
  styleUrl: './order-details.component.scss',
  standalone: false,
})
export class OrderDetailsComponent {
  @Input() business: Pick<AccountGroup, 'externalIdentifiers' | 'napData' | 'accountGroupId'>;
  @Input() contractStartDate: Date;
  @Input() contractDuration: DurationInterface;
  @Input() config: OrderDetailsComponentConfig;
  @Input() isLoading = false;
  @Input() viewOnly = false;
  @Input() companyLink: string;

  @Output() nameClicked = new EventEmitter<null>();
  @Output() contractStartDateChanged = new EventEmitter<Date>();
  @Output() contractDurationChanged = new EventEmitter<DurationInterface>();
}
